module.exports = __webpack_public_path__ + "img/unlink-icon.0196777c.svg";